[
  {
    "id": "round",
    "x": 16,
    "y": 20,
    "w": 238,
    "h": 94
  },
  {
    "id": "logo",
    "x": 288,
    "y": 8,
    "w": 404,
    "h": 250
  },
  {
    "id": "sticker.l",
    "x": 56,
    "y": 138,
    "w": 174,
    "h": 132
  },
  {
    "id": "sticker.r",
    "x": 798,
    "y": 178,
    "w": 142,
    "h": 136
  },
  {
    "id": "seat4.ring",
    "x": 452,
    "y": 258,
    "w": 192,
    "h": 176
  },
  {
    "id": "seat1.ring",
    "x": 18,
    "y": 282,
    "w": 158,
    "h": 152
  },
  {
    "id": "seat2.ring",
    "x": 176,
    "y": 282,
    "w": 144,
    "h": 152
  },
  {
    "id": "seat3.ring",
    "x": 320,
    "y": 282,
    "w": 132,
    "h": 152
  },
  {
    "id": "seat5.ring",
    "x": 644,
    "y": 282,
    "w": 136,
    "h": 152
  },
  {
    "id": "seat6.ring",
    "x": 780,
    "y": 282,
    "w": 148,
    "h": 152
  },
  {
    "id": "seat1.pill",
    "x": 26,
    "y": 434,
    "w": 144,
    "h": 34
  },
  {
    "id": "seat2.pill",
    "x": 170,
    "y": 434,
    "w": 142,
    "h": 34
  },
  {
    "id": "seat3.pill",
    "x": 314,
    "y": 434,
    "w": 142,
    "h": 34
  },
  {
    "id": "seat4.pill",
    "x": 470,
    "y": 434,
    "w": 156,
    "h": 34
  },
  {
    "id": "seat5.pill",
    "x": 630,
    "y": 434,
    "w": 142,
    "h": 34
  },
  {
    "id": "seat6.pill",
    "x": 776,
    "y": 434,
    "w": 144,
    "h": 34
  },
  {
    "id": "question",
    "x": 52,
    "y": 466,
    "w": 836,
    "h": 246
  },
  {
    "id": "noway",
    "x": 590,
    "y": 928,
    "w": 270,
    "h": 152
  },
  {
    "id": "row1",
    "x": 108,
    "y": 702,
    "w": 724,
    "h": 90
  },
  {
    "id": "row2",
    "x": 108,
    "y": 792,
    "w": 724,
    "h": 86
  },
  {
    "id": "row3",
    "x": 108,
    "y": 878,
    "w": 724,
    "h": 88
  },
  {
    "id": "row4",
    "x": 108,
    "y": 966,
    "w": 488,
    "h": 84
  },
  {
    "id": "row5",
    "x": 108,
    "y": 1050,
    "w": 724,
    "h": 88
  },
  {
    "id": "row6",
    "x": 108,
    "y": 1138,
    "w": 724,
    "h": 86
  },
  {
    "id": "alltheway",
    "x": 102,
    "y": 1223,
    "w": 736,
    "h": 133
  },
  {
    "id": "cta",
    "x": 90,
    "y": 1349,
    "w": 760,
    "h": 145
  },
  {
    "id": "callit",
    "x": 146,
    "y": 1494,
    "w": 648,
    "h": 78
  }
]
